//Libs
import React, { Component, Fragment } from 'react';
import randomColor from 'randomcolor';
//Componentes Material
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
//Ícones
import BusinessIcon from '@material-ui/icons/Business';
//Gráficos
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend, AreaChart, XAxis, YAxis, Area } from 'recharts';
//Components
import CenteredCircularProgress from '../CenteredCircularProgress';
import CustomizedAxisTick from './CustomizedAxisTick';
//Controllers
import RelatorioController from '../../controllers/RelatorioController';
//Modelos
import Empresas from '../../models/relatorios/Empresas';
//Utils
import { formatarDataMes } from '../../utils/formatarData';



/**
 * Componente para exibir os gráficos dos relatórios de empresas
 */
class RelatorioEmpresas extends Component {
    constructor(props) {
        super(props);
        //Controllers
        this.relatorioController = new RelatorioController();
        //Estado inicial
        this.state = {
            carregando: true,
            dados: Empresas.clone({ }),
            erros: [ ]
        };
    }

    async componentDidMount() {
        //Consulta os dados da API
        const result = await this.relatorioController.empresas();
        //Caso a consulta ocorra com sucesso
        if (result.sucesso) {
            this.setState({ carregando: false, dados: result.dados });
        } else {
            this.setState({ carregando: false, erros: result.erros });
        }

    }

    /**
     * Renderiza o gráfico de empresas agrupadas por tipo
     * @return {Object} Retorna o componente do gráfico
     */
    renderizarGraficoTipo() {
        const { dados } = this.state;
        const cores = randomColor({ count: dados.tipo.length, seed: 0 });

        return (
            <ResponsiveContainer height={200} >
                <PieChart>
                    <Pie data={dados.tipo} dataKey="quantidade" nameKey="rotulo">
                        { dados.tipo.map((item, i) => (<Cell key={item.rotulo} fill={cores[i]} />)) }
                    </Pie>
                    <Tooltip />
                    <Legend align="left" verticalAlign="middle" layout="vertical" />
                </PieChart>
            </ResponsiveContainer>
        );
    }

    /**
     * Renderiza o gráfico de empresas ativas por período
     * @return {Object} Retorna o componente do gráfico
     */
    renderizarGraficoAtivas() {
        const { dados } = this.state;
        const itensFormatados = dados.ativas.map(item => ({ data: formatarDataMes(new Date(item.data)), quantidade: item.quantidade }));

        return (
            <ResponsiveContainer height={200} >
                <AreaChart data={itensFormatados} margin={{top: 5, right: 15, left: 5, bottom: 40}}>
                    <XAxis dataKey="data" interval="preserveStart" tick={<CustomizedAxisTick />} />
                    <YAxis type="number" allowDecimals={false} />
                    <Tooltip/>
                    <Area dataKey="quantidade" stroke="#8884d8" fill="#8884d8" />
                </AreaChart>
            </ResponsiveContainer>
        );
    }

    render() {
        const { carregando } = this.state;
        return (
            <Fragment>
                <Grid item xs={12} sm={12} md={8} >
                    <Card>
                        <CardHeader avatar={<BusinessIcon />} title="Empresas ativas" />
                        <CardContent>
                            { carregando && <CenteredCircularProgress />  }
                            { !carregando && this.renderizarGraficoAtivas() }
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4} >
                    <Card>
                        <CardHeader avatar={<BusinessIcon />} title="Empresas por tipo" />
                        <CardContent>
                            { carregando && <CenteredCircularProgress />  }
                            { !carregando && this.renderizarGraficoTipo() }
                        </CardContent>
                    </Card>
                </Grid>
            </Fragment>
        );
    }
}

export default RelatorioEmpresas;